<div class="union-status-page suspended">
  <div class="status-container">
    <div class="status-content">
      <!-- Header Section -->
      <div class="status-header">
        <div class="status-icon">
          <i class="fas fa-ban"></i>
        </div>
        <h1 class="status-title bangla-heading">ইউনিয়ন সাময়িকভাবে বন্ধ</h1>
        <h2 class="union-name bangla-text" *ngIf="statusData && statusData.unionName">
          {{ statusData.unionName }}
        </h2>
      </div>

      <!-- Message Section -->
      <div class="status-message">
        <div class="message-content">
          <i class="fas fa-info-circle"></i>
          <div class="message-text">
            <p class="primary-message bangla-text">
              আপনার ইউনিয়ন সিস্টেম সাময়িকভাবে নিষ্ক্রিয় করা হয়েছে।
            </p>
            <p class="secondary-message bangla-text" *ngIf="statusData && statusData.reason">
              <strong>কারণ:</strong> {{ statusData.reason }}
            </p>
            <p class="suspension-time bangla-text" *ngIf="statusData && statusData.suspendedAt">
              <strong>স্থগিত করা হয়েছে:</strong> {{ formatDate(statusData.suspendedAt) }}
            </p>
          </div>
        </div>
      </div>

      <!-- Instructions Section -->
      <div class="instructions-section">
        <h3 class="instructions-title bangla-heading">কী করবেন?</h3>
        <div class="instructions-list">
          <div class="instruction-item">
            <i class="fas fa-phone"></i>
            <div class="instruction-content">
              <h4 class="bangla-text">সাপোর্ট টিমের সাথে যোগাযোগ করুন</h4>
              <p class="bangla-text">সমস্যা সমাধানের জন্য আমাদের সাপোর্ট টিমের সাথে যোগাযোগ করুন।</p>
            </div>
          </div>
          
          <div class="instruction-item">
            <i class="fas fa-clock"></i>
            <div class="instruction-content">
              <h4 class="bangla-text">অপেক্ষা করুন</h4>
              <p class="bangla-text">সমস্যা সমাধান হলে আপনার ইউনিয়ন পুনরায় সক্রিয় করা হবে।</p>
            </div>
          </div>

          <div class="instruction-item">
            <i class="fas fa-envelope"></i>
            <div class="instruction-content">
              <h4 class="bangla-text">ইমেইল চেক করুন</h4>
              <p class="bangla-text">আপনার নিবন্ধিত ইমেইলে আপডেট পাঠানো হবে।</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section -->
      <div class="contact-section">
        <h3 class="contact-title bangla-heading">সহায়তার জন্য যোগাযোগ</h3>
        <div class="contact-methods">
          <div class="contact-method">
            <i class="fas fa-phone-alt"></i>
            <div class="contact-info">
              <span class="contact-label bangla-text">ফোন:</span>
              <a href="tel:+8801XXXXXXXXX" class="contact-value">+৮৮০ ১XXX-XXXXXX</a>
            </div>
          </div>
          
          <div class="contact-method">
            <i class="fas fa-envelope"></i>
            <div class="contact-info">
              <span class="contact-label bangla-text">ইমেইল:</span>
              <a href="mailto:support@digitalunion.gov.bd" class="contact-value">support&#64;digitalunion.gov.bd</a>
            </div>
          </div>

          <div class="contact-method">
            <i class="fas fa-clock"></i>
            <div class="contact-info">
              <span class="contact-label bangla-text">সময়:</span>
              <span class="contact-value bangla-text">সকাল ৯টা - সন্ধ্যা ৬টা (রবি-বৃহস্পতিবার)</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-section">
        <button type="button" class="btn-primary-action" (click)="contactSupport()">
          <i class="fas fa-phone"></i>
          <span class="bangla-text">এখনই ফোন করুন</span>
        </button>
        
        <button type="button" class="btn-secondary-action" (click)="goToLogin()">
          <i class="fas fa-arrow-left"></i>
          <span class="bangla-text">লগইন পেজে ফিরে যান</span>
        </button>
      </div>

      <!-- Footer -->
      <div class="status-footer">
        <p class="footer-text bangla-text">
          <i class="fas fa-shield-alt"></i>
          Digital Union Management System - Powered by Government of Bangladesh
        </p>
      </div>
    </div>
  </div>
</div>